import * as SentryReact from '@sentry/react';
import type {AnalyticsSink} from '../types';

// Sentry is only initialised in SentryWrapper when !DEBUG_ENABLED;
// captureException is a no-op without a client.
export const sentrySink: AnalyticsSink = {
  name: 'sentry',
  error(err, context) {
    SentryReact.captureException(err, {extra: context});
  },
};
